import React from 'react'
import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import {
  DragNDropFileUploader as CoreDragNDropFileUploader,
  IDragNDropFileUploaderProps,
  TDnDTextRenderTypes,
} from 'core-components/library/dragNDropFileUploader'

export const DragNDropFileUploader = (props: IDragNDropFileUploaderProps) => {
  const textRender = useCallback((type: TDnDTextRenderTypes) => {
    if (type === 'dndCommentText') {
      return (
        <Translation
          text={'core-dragndrop-drag-n-drop-your-attachments-in-here-or'}
          actionsInside
          span
        />
      )
    }
    if (type === 'dndBrowseWord') {
      return <Translation text={'core-dragndrop-browse'} actionsInside span />
    }
    if (type === 'dndOrWord') {
      return <Translation text={'core-dragndrop-or'} actionsInside span />
    }

    return null
  }, [])

  return <CoreDragNDropFileUploader {...props} textRender={textRender} />
}
